const zh = {
  "srv_general_unknown": "出现问题，请重试。",
  "srv_general_network": "网络错误，请检查连接。",
  "srv_general_timeout": "请求超时，请重试。",
  "srv_general_not_found": "未找到",
  "srv_general_invalid_id": "无效 id",
  "srv_general_invalid_json": "无效 JSON",
  "srv_auth_admin_only": "仅管理员可用",
  "srv_auth_owner_only": "仅所有者可访问",
  "srv_auth_unauthorized": "未授权",
  "srv_auth_not_authenticated": "未登录",
  "srv_auth_invalid_token": "无效 token",
  "srv_auth_session_expired": "无刷新 token",
  "srv_auth_token_expired": "Token 已过期",
  "srv_auth_device_signed_out": "此设备已退出登录",
  "srv_auth_invalid_login": "用户名/邮箱或密码无效",
  "srv_auth_wrong_password": "当前密码不正确",
  "srv_auth_email_already_exists": "邮箱已注册",
  "srv_auth_email_taken_other": "该邮箱现已被其他账户使用",
  "srv_auth_same_email": "这已是您的邮箱",
  "srv_auth_same_username": "这已是您的用户名",
  "srv_auth_username_taken": "用户名已被占用",
  "srv_auth_username_invalid": "用户名须为 3-20 个字母、数字或下划线",
  "srv_auth_user_not_found": "未找到用户",
  "srv_auth_password_mismatch": "两次密码不一致",
  "srv_auth_password_weak": "新密码至少须 8 个字符，并包含字母和数字",
  "srv_auth_password_same": "新密码须与当前密码不同",
  "srv_auth_rate_limited": "尝试次数过多，请稍后重试。",
  "srv_auth_signup_rate_limited": "此网络注册次数过多，请稍后再试。",
  "srv_auth_verify_link_invalid": "验证链接无效或已使用",
  "srv_auth_verify_link_expired": "验证链接已过期，请重新申请。",
  "srv_auth_email_already_verified": "邮箱已验证。",
  "srv_auth_verification_sent": "验证邮件已发送。",
  "srv_auth_email_change_sent": "验证链接已发送至新邮箱，确认后完成更改。",
  "srv_auth_reset_link_invalid": "重置链接无效或已过期",
  "srv_auth_reset_sent": "如账户存在，重置链接已发送。",
  "srv_auth_password_updated": "密码已更新，请使用新密码登录。",
  "srv_auth_password_changed": "密码已更改，请在其他设备上重新登录。",
  "srv_auth_signed_out_all": "已退出所有设备",
  "srv_auth_signed_out_others": "已退出其他所有设备",
  "srv_auth_device_revoked": "设备已退出登录",
  "srv_subscription_required": "此功能仅限 Premium 会员",
  "srv_subscription_plan_unavailable": "测试方案不可用。",
  "srv_subscription_order_not_found": "未找到订单",
  "srv_payment_provider_unreachable": "无法连接支付服务商，请重试。",
  "srv_payment_invoice_failed": "支付服务商无法创建发票，请重试。",
  "srv_payment_not_configured": "加密支付网关尚未配置，请添加 NOWPayments API 密钥。",
  "srv_payment_invalid_signature": "无效签名",
  "srv_exchange_connection_not_found": "未找到连接",
  "srv_exchange_unsupported": "不支持的交易所",
  "srv_exchange_unreachable": "服务器无法连接交易所",
  "srv_exchange_key_not_readonly": "此 API 密钥具有交易/提现权限。请创建只读密钥（禁用交易和提现）。",
  "srv_exchange_verify_first": "启用实盘交易前请先验证连接",
  "srv_insufficient_balance": "金额超过可用余额",
  "srv_trade_amount_positive": "金额必须大于 0",
  "srv_trade_invalid_withdrawal": "无效提现金额",
  "srv_trade_bot_needs_tp_sl": "机器人需要同时设置止损和止盈",
  "srv_trade_no_position": "没有可卖出的持仓",
  "srv_trade_position_not_found": "未找到持仓",
  "srv_trade_symbol_required": "必须填写交易对",
  "srv_trade_invalid_symbol": "无效交易对",
  "srv_trade_invalid_interval": "无效周期",
  "srv_trade_verify_email": "开仓前请验证您的邮箱。",
  "srv_trade_verify_email_auto": "启用自动交易前请验证您的邮箱。",
  "srv_trade_demo_min": "模拟余额最低为 100",
  "srv_trade_demo_max": "模拟余额过高（最高 10,000,000）",
  "srv_trade_leverage_confirm": "杠杆超过 20x 需二次确认",
  "srv_trade_high_risk_confirm": "风险超过 15% 需确认高风险",
  "srv_trade_high_liquidation_risk": "爆仓风险高",
  "srv_trade_no_fee": "无费用（持有 7+ 天）。",
  "srv_insufficient_data": "此回测的K线数据不足",
  "srv_notification_not_found": "未找到通知",
  "srv_nft_image_failed": "图片生成失败",
  "ntf_cloud_enabled": "云端交易已启用，机器人将 24/7 运行。",
  "ntf_cloud_disabled": "云端交易已禁用。",
  "srv_trade_no_price": "{symbol} 暂无价格",
  "srv_trade_risk_lock": "风险锁定：每笔交易最高为余额的 {pct}%",
  "srv_trade_max_leverage": "{symbol} 的最高杠杆为 {max}x",
  "srv_trade_risk_range": "{symbol} 的风险必须介于 1% 和 {max}% 之间",
  "srv_payment_unsupported_currency": "不支持的货币。请选择以下之一：{list}",
  "srv_exchange_unsupported_named": "不支持的交易所：{name}",
  "srv_auth_username_cooldown": "{days} 天后可再次修改用户名",
  "srv_exchange_connection_error": "连接错误：{error}",
  "srv_trade_early_fee": "已收取 5%（{fee}）的提前提现手续费。",
  "ntf_risk_drawdown": "最大回撤 {dd}% 已达到 {limit}% 上限。所有仓位已平仓，机器人已停止。",
  "ntf_risk_losses": "连续亏损 {count} 次。机器人已停止，请确认后恢复。",
  "ntf_cooldown": "连续亏损 {count} 次后冷却中，新开仓暂停 {minutes} 分钟。",
  "ntf_trade_opened": "已开仓：{symbol} {timeframe} · 评分 {score} · {leverage}",
  "ntf_nft_opened": "NFT 仓位已开立（Demo）：{name}",
  "ntf_nft_closed": "NFT 仓位已平仓（Demo）：P&L {pnl}",
  "ntf_trade_closed": "{reason}：{symbol} 已平仓 · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · 评分 {score}。入场价 ${entry} / TP ${tp} / SL ${sl}。仅供参考，不构成投资建议。",
  "app_name": "FIREBIRD AI",
  "tagline": "AI 加密货币与 NFT 交易",
  "login": "登录",
  "register": "注册",
  "logout": "退出登录",
  "email": "邮箱",
  "password": "密码",
  "name": "姓名",
  "welcome_back": "欢迎回来，交易者",
  "create_account": "创建您的账户",
  "no_account": "还没有账户？",
  "have_account": "已有账户？",
  "account_created": "账户已创建 — $100 模拟资金已就绪",
  "loading": "加载中…",
  "demo_mode": "模拟模式",
  "demo_balance": "模拟余额",
  "nav_dashboard": "仪表盘",
  "nav_charts": "实时图表",
  "nav_signals": "AI 信号",
  "nav_autotrade": "自动交易",
  "nav_manual": "手动交易",
  "nav_scanner": "Memecoin 扫描器",
  "nav_backtest": "5×5 回测",
  "nav_positions": "持仓与报告",
  "nav_nft": "NFT 系列",
  "nav_assistant": "AI 助手",
  "nav_settings": "交易所与设置",
  "nav_subscription": "高级套餐",
  "subscription_subtitle": "解锁高级交易智能 — 使用加密货币支付。",
  "current_plan": "当前套餐",
  "premium": "高级版",
  "free_plan": "免费套餐",
  "renews_on": "续费日期",
  "active": "生效中",
  "best_value": "最超值",
  "plan_monthly": "月付",
  "plan_annual": "年付",
  "plan_test": "测试",
  "days": "天",
  "pay_with_crypto": "使用加密货币支付",
  "opening_checkout": "正在打开收银台…",
  "gateway_not_ready": "加密货币支付网关尚未配置。添加 NOWPayments API 密钥后即可启用高级版结账。",
  "premium_only": "仅限高级版",
  "premium_gate_desc": "此功能属于 FireBird 高级版。升级后可解锁完整的 AI 信号、自动交易和机会扫描器。",
  "go_premium": "升级高级版",
  "billing_history": "账单记录",
  "no_invoices": "暂无账单。您的加密货币支付将显示在这里。",
  "date": "日期",
  "plan_col": "套餐",
  "amount_col": "金额",
  "status_col": "状态",
  "view_invoice": "查看账单",
  "check_status": "检查支付状态",
  "checking": "检查中…",
  "payment_still_pending": "尚未确认支付。我们会自动继续检查。",
  "status_paid": "已支付",
  "status_created": "待处理",
  "status_partially_paid": "部分支付",
  "status_expired": "已过期",
  "status_failed": "失败",
  "status_refunded": "已退款",
  "status_cancelled": "已取消",
  "status_canceled": "已取消",
  "payment_processing": "已检测到支付 — 正在激活您的高级套餐…",
  "payment_success": "高级版已激活。欢迎加入！",
  "payment_cancelled": "支付已取消。",
  "payment_error": "无法启动结账，请重试。",
  "popup_blocked": "结账已就绪。如果没有打开新标签页，请使用下方链接。",
  "checkout_opened_hint": "结账页已在新标签页中打开。没有看到？",
  "open_checkout": "打开结账页",
  "pay_currency_label": "支付方式",
  "pay_currency_hint": "我们支持 Solana 上的 USDC 和 BSC 上的 BNB。所选资产将在结账时锁定。",
  "feat_signals": "完整 AI 信号（加密货币、Shitcoin、NFT）",
  "feat_autotrade": "带风险管理的自动交易",
  "feat_scanner": "Memecoin 与机会扫描器",
  "feat_alerts": "智能邮件提醒",
  "feat_priority": "优先信号推送",
  "feat_save": "相比月付全年免费 2 个月",
  "feat_test_quick": "一次性 $1 测试 — 验证真实支付流程",
  "demo_account_settings": "模拟账户设置",
  "demo_settings_desc": "设置自定义模拟余额并重置您的模拟交易账户。这只影响模拟数据 — 绝不会影响您的订阅或任何实盘交易。",
  "custom_demo_balance": "自定义模拟余额 (USDC)",
  "demo_min_hint": "默认 500 · 最低 100",
  "reset_demo_account": "重置模拟账户",
  "reset_demo_confirm_title": "重置模拟账户？",
  "reset_demo_confirm_desc": "这将把您的模拟余额设为 ${bal}，删除所有模拟交易和盈亏记录，并清除回撤、暂停和冷却状态。此操作无法撤销。您的订阅和实盘数据不受影响。",
  "demo_reset_done": "模拟账户已重置 — 余额已设为 ${bal}",
  "demo_min_balance_error": "最低模拟余额为 100",
  "nav_guide": "新手指南",
  "owner_console": "所有者控制台",
  "total_value": "总价值",
  "cash": "现金",
  "holdings": "持仓资产",
  "unrealized_pnl": "未实现盈亏",
  "top_signals": "顶级 AI 信号",
  "market_overview": "市场概览",
  "whale_activity": "鲸鱼与聪明资金",
  "market_pulse": "市场脉搏",
  "news_up": "{name} 24 小时内上涨 {pct}%",
  "news_down": "{name} 24 小时内下跌 {pct}%",
  "kind_cex": "CEX",
  "kind_iranian_cex": "伊朗 CEX",
  "kind_dex": "DEX",
  "price": "价格",
  "change_24h": "24 小时",
  "score": "评分",
  "action": "操作",
  "buy": "买入",
  "sell": "卖出",
  "hold": "持有",
  "timeframe": "时间周期",
  "symbol": "代码",
  "amount_usd": "金额 (USD)",
  "open_position": "开仓",
  "close": "平仓",
  "no_positions": "暂无未平仓位",
  "entry": "开仓价",
  "current": "当前",
  "exit": "平仓价",
  "reason": "原因",
  "pnl": "盈亏",
  "win_rate": "胜率",
  "total_trades": "总交易数",
  "total_pnl": "总盈亏",
  "wl": "胜 / 负",
  "open_label": "持仓中",
  "run_backtest": "运行回测",
  "running": "运行中…",
  "bt_subtitle": "策略在每个时间周期的 5 个历史窗口上进行测试。",
  "window_results": "窗口结果",
  "window": "窗口",
  "trades": "交易数",
  "return_label": "收益",
  "max_drawdown": "最大回撤",
  "auto_trade_on": "自动交易已启用",
  "auto_trade_off": "自动交易已关闭",
  "enable_autotrade": "启用自动交易（模拟）",
  "reset_demo": "重置模拟（$100）",
  "activity_log": "活动日志",
  "waiting_signals": "等待信号…",
  "enable_to_start": "启用自动交易以开始",
  "reauthorize_bot": "重新授权机器人",
  "leverage": "杠杆",
  "high_leverage_warning": "高杠杆 — 您可能会损失全部保证金（强平）。",
  "bot_description": "机器人会在 15m / 1h / 4h 周期扫描所有币种，选择最佳信号入场（盈亏比 2:1，必须设置止损），并在模拟模式下用追踪止盈管理持仓。",
  "rule_rr": "盈亏比 2:1（必须设置止损）",
  "rule_max_concurrent": "最多 2 笔同时自动交易",
  "rule_leverage": "自动杠杆 ≤ 10x · 手动 ≤ 50x",
  "rule_circuit": "回撤达 20% 时触发熔断",
  "rule_halt": "连续 5 次亏损后暂停",
  "rule_scan": "扫描所有币种和时间周期",
  "rule_entry": "在 {tfs} 上入场评分 ≥ {score}",
  "rule_cooldown": "连续 {losses} 次亏损后冷却 {min} 分钟",
  "risk_status": "风险状态",
  "risk_mode_active": "运行中",
  "risk_mode_halted": "已暂停",
  "consecutive_losses_label": "连续亏损次数",
  "drawdown_label": "回撤",
  "open_positions_label": "未平仓位",
  "max_concurrent_reached": "已达到最大同时交易数。",
  "bot_reauthorized": "机器人已重新授权。您可以再次启用自动交易。",
  "cloud_trading": "云端交易",
  "enable_cloud": "启用云端交易",
  "disable_cloud": "停用云端交易",
  "cloud_status": "云端状态",
  "cloud_on": "全天候运行中 24/7",
  "cloud_off": "关闭",
  "cloud_desc": "机器人在我们的服务器上 24/7 运行，即使您的设备关机也不会停止。",
  "notifications": "通知",
  "no_notifications": "暂无通知",
  "mark_all_read": "全部标记为已读",
  "connect_exchange": "连接交易所",
  "api_key": "API 密钥",
  "api_secret": "API 密文",
  "api_key_optional": "API 密钥（公开行情可选）",
  "connect": "连接",
  "test": "测试",
  "remove": "移除",
  "verified": "已验证",
  "not_verified": "未验证",
  "connected_exchanges": "已连接的交易所",
  "aggregated_balances": "余额 · 所有交易所",
  "aggregated_prices": "实时价格 · 所有交易所",
  "no_connections": "尚未连接任何交易所。",
  "connect_wallet": "连接钱包",
  "wallet_connected": "钱包已连接",
  "wallet_note": "非托管 — 我们绝不保存您的私钥。",
  "wallet_security": "钱包与安全",
  "wallet_never_ask": "我们绝不会要求您提供私钥或助记词。",
  "disconnect_wallet": "断开钱包",
  "switch_chain": "切换网络",
  "native_balance": "原生代币余额",
  "wallet_chain": "网络",
  "dex_onchain": "DEX（链上）",
  "sign_in_wallet": "使用钱包登录",
  "waiting_signature": "等待钱包签名…",
  "dex_demo_note": "您使用自己的钱包签名 — 密钥绝不会离开您的设备。",
  "view_on_explorer": "在区块浏览器中查看",
  "wallet_required_dex": "请连接钱包以进行链上交易。",
  "tx_pending": "交易待确认…",
  "tx_confirmed": "交易已确认",
  "tx_failed": "交易失败",
  "connected_label": "已连接",
  "not_connected_label": "未连接",
  "copy_address": "复制地址",
  "readonly_warning": "创建 API 密钥时请仅授予只读权限。禁用提现和交易权限。",
  "cex_security_notice": "我们绝不保存您的私钥，也不会申请提现权限。",
  "api_passphrase_optional": "口令（可选）",
  "read_only_label": "只读",
  "how_to_create_key": "如何创建只读密钥",
  "connected_wallets": "已连接的钱包",
  "no_wallet_connected": "未连接钱包。",
  "no_exchange_linked": "未绑定交易所。",
  "smart_contract_allowances": "智能合约授权",
  "no_allowances": "暂无有效授权。",
  "revoke": "撤销",
  "max_spend": "最大花费",
  "link_readonly_hint": "请使用“连接交易所”面板绑定只读密钥。",
  "vpn_notice": "此市场对某些地区的用户可能需要 VPN。",
  "ir_friendly": "支持伊朗",
  "best_price": "最优价格",
  "marketplace_listings": "市场挂单",
  "tab_opps": "机会",
  "opportunities": "机会",
  "high_opportunity": "高机会",
  "alerts_triggered_today": "今日触发的提醒",
  "score_range": "评分范围",
  "timeframe_label": "时间周期",
  "direction_label": "方向",
  "risk_disclaimer_title": "风险提示",
  "risk_disclaimer": "信号仅供参考，不构成投资建议。98% 的 Shitcoin 会失败。请始终设置止损。单笔交易风险切勿超过 1-5%。",
  "no_opportunities": "目前没有机会。扫描器每 5 分钟运行一次。",
  "alerts_title": "提醒",
  "enable_scanner": "启用自动扫描器",
  "min_score_label": "最低评分",
  "monitor_timeframes": "要监控的时间周期",
  "max_alerts_day": "每日最多提醒次数",
  "notify_method_label": "通知方式",
  "notify_in_app": "仅应用内",
  "notify_in_app_email": "应用内 + 邮件",
  "alert_history_title": "提醒历史",
  "no_alert_history": "暂无提醒。",
  "nft_markets": "NFT 市场",
  "iran_friendly": "支持伊朗",
  "key_security_note": "密钥在服务器上加密，绝不保存在您的浏览器中。",
  "exchange": "交易所",
  "no_balances": "暂无余额（添加 API 密钥以加载实时余额）。",
  "safety": "安全性",
  "opportunity": "机会",
  "holders": "持币地址",
  "verdict": "结论",
  "coin": "币种",
  "chain": "公链",
  "scanning": "扫描中…",
  "scanner_subtitle": "精选具有可交易流动性的 Memecoin（评分 ≥ 75）。不显示未知或诈骗代币。",
  "safety_note": "安全性 = 流动性锁定 + 放弃增发权限 + 持币分布（仅供参考，不构成投资建议）。",
  "ask_ai": "向 Firebird AI 提问...",
  "send": "发送",
  "chat": "聊天",
  "ai_empty": "可询问某个币种、时间周期或策略。一切内容均不构成投资建议。",
  "ai_thinking": "Firebird AI 正在思考…",
  "ai_error": "抱歉，我现在无法回复。",
  "score_coin": "为此币种评分",
  "any_coin_symbol": "任意币种代码",
  "analyzing": "分析中…",
  "entry_strategy": "入场",
  "exit_strategy": "出场",
  "risk": "风险",
  "signals_subtitle": "AI + 技术评分，覆盖各币种",
  "momentum": "动量",
  "simulated_feed": "模拟数据",
  "collection": "Firebird 555 系列",
  "nft_subtitle": "Firebird / 凤凰 — 555 件 · 6 个传说稀有款 · 每一件都有自己的毁灭与重生故事",
  "rares": "传说稀有款",
  "floor_price": "地板价",
  "minted": "已铸造",
  "total_supply": "总供应量",
  "rarity": "稀有度",
  "bt_download": "下载",
  "bt_stop_loss": "止损（TP = 2× SL）",
  "bt_min_score": "最低信号评分",
  "bt_share": "分享",
  "bt_history": "已保存的回测记录",
  "bt_card_saved": "结果卡片已下载",
  "bt_compare_tf": "比较时间周期",
  "bt_best": "最佳",
  "bt_worst": "最差",
  "bt_run_all": "运行所有币种",
  "bt_by_section": "按类别查看结果",
  "bt_per_coin": "每个币种结果",
  "bt_avg_return": "平均收益",
  "bt_skipped": "已跳过（数据不足）",
  "bt_sec_major": "主流币",
  "bt_sec_shitcoin": "山寨币",
  "bt_sec_meme": "迷因",
  "bt_sec_nft": "NFT 代币",
  "bt_sec_other": "其他",
  "bt_data_live": "实时市场数据",
  "bt_data_simulated": "模拟数据（实时市场不可用）",
  "risk_per_trade": "单笔交易风险",
  "max_amount": "最大",
  "tier_major": "主流币",
  "tier_mid": "中市值",
  "tier_meme": "Meme/拉盘",
  "high_risk_ack": "我了解这是一笔高风险交易（超过我余额的 15%）。",
  "lev_warn_yellow": "强平风险高",
  "lev_warn_red": "极端杠杆 — 强平风险极高。需要二次确认。",
  "lev_ack": "我了解我可能会损失全部保证金。",
  "lev_confirm_again": "极端杠杆：再次点击以确认。",
  "confirm_again": "再次确认",
  "high_risk_required": "请勾选高风险确认。",
  "lev_ack_required": "请确认极端杠杆警告。",
  "trait_element": "元素",
  "trait_aura": "光环",
  "trait_background": "背景",
  "prev": "上一页",
  "next": "下一页",
  "all": "全部",
  "save": "保存",
  "risk_lock": "风险锁",
  "max_position": "最大仓位 %",
  "trailing_stop": "追踪止损 %",
  "take_profit": "止盈 %",
  "stop_loss": "止损 %",
  "risk_strategy": "风险与策略",
  "exchanges": "交易所连接",
  "connected": "已连接",
  "disconnected": "未连接",
  "withdraw_demo_wallet": "提现（模拟钱包）",
  "withdraw_fee_note": "在最近一次充值后 7 天内提现将收取 5% 的提前提现费（所有者分成）。",
  "withdraw": "提现",
  "trade_history": "交易记录",
  "no_closed_trades": "暂无已平仓交易",
  "owner_subtitle": "所有用户的只读业绩 · 佣金账本（每笔盈利交易 2%，每周结算 · 提前提现费 5%）",
  "total_users": "用户总数",
  "total_commission": "佣金总额",
  "this_week": "本周",
  "total_volume": "总成交量",
  "all_time": "历史累计",
  "settles_weekly": "每周结算",
  "commission_breakdown": "佣金明细",
  "from_trade_profits": "来自交易利润 (2%)",
  "from_withdrawal_fees": "来自提前提现费 (5%)",
  "owner_rate": "所有者费率",
  "settlement": "结算",
  "early_exit_fee": "提前退出费",
  "weekly": "每周",
  "daily_accrual": "每日计提",
  "no_commission_yet": "暂无佣金 — 将在盈利交易中累计。",
  "users_performance": "用户业绩（只读）",
  "col_user": "用户",
  "col_role": "角色",
  "col_joined": "加入时间",
  "col_volume": "成交量",
  "col_balance": "余额",
  "role_owner": "所有者",
  "role_user": "用户",
  "guide_intro": "欢迎使用 Firebird AI Trade。按照以下步骤安全上手。",
  "guide_step": "步骤",
  "guide1_title": "模拟模式已开启",
  "guide1_desc": "您从 $100 模拟余额开始。在您用自己的安全密钥明确启用实盘交易之前，不会使用任何真实资金。",
  "guide2_title": "查看仪表盘",
  "guide2_desc": "在一个地方查看组合价值、顶级 AI 信号、市场概览、鲸鱼动态和市场脉搏。",
  "guide3_title": "查看 AI 信号",
  "guide3_desc": "币种根据 RSI、SMA 交叉和多个时间周期的动量进行 0-100 评分。",
  "guide4_title": "询问 AI 助手",
  "guide4_desc": "获取币种评分以及来自 Firebird AI Core (GPT-5.6) 的入场/出场策略和风险提示。",
  "guide5_title": "试用自动交易（模拟）",
  "guide5_desc": "让机器人在强信号时开买入仓位，并用追踪止损 / 止盈进行管理。",
  "guide6_title": "扫描 Memecoin",
  "guide6_desc": "只显示安全评分高的可交易 Memecoin — 不显示未知或诈骗代币。",
  "guide7_title": "探索 Firebird 555 NFT",
  "guide7_desc": "浏览包含 555 件作品和 6 个传说稀有款的凤凰系列。",
  "disclaimer": "模拟/沙盒模式。这里的一切都不构成投资建议。任何系统都无法保证未来的胜率。",
  "src_manual": "手动",
  "src_auto": "自动",
  "tier_legendary": "传说",
  "tier_epic": "史诗",
  "tier_rare": "稀有",
  "tier_common": "普通",
  "verdict_tradeable": "可交易",
  "verdict_watch": "观察",
  "pressure_accumulation": "吸筹",
  "pressure_distribution": "派发",
  "reason_take_profit": "止盈",
  "reason_liquidation": "强平",
  "reason_stop_loss": "止损",
  "reason_trailing_take_profit": "追踪止盈",
  "reason_trailing_stop": "追踪止损",
  "reason_signal_flip": "信号反转",
  "welcome": "欢迎",
  "trader": "交易者",
  "live": "实时",
  "verify_email_banner": "请验证邮箱以开仓。请在收件箱中查找验证链接。",
  "resend": "重新发送",
  "verification_sent": "验证邮件已发送",
  "could_not_resend": "无法重新发送",
  "search_coin_placeholder": "搜索任意币种（例如 BTC、PEPE、ARB）",
  "add_to_watchlist": "添加到自选列表",
  "free_balance": "可用余额",
  "in_positions": "持仓中",
  "total_equity": "总权益",
  "watchlist": "自选列表",
  "watchlist_empty": "暂无币种 — 搜索并点击 + 添加。",
  "high_exposure": "正在使用您可用余额的 {percent}% — 风险敞口较高。",
  "advanced_tpsl": "高级止盈 / 止损",
  "entry_optional": "入场价（可选 — 默认市价）",
  "market": "市价",
  "take_profit_price": "止盈价格",
  "stop_loss_price": "止损价格",
  "tp_example": "例如 72000",
  "sl_example": "例如 66000",
  "if_tp_hits": "触发止盈时",
  "if_sl_hits": "触发止损时",
  "pnl_preview_note": "基于 ${amount} 保证金 × {leverage}x。线条已绘制在图表上 →",
  "clear_tpsl": "清除止盈/止损",
  "one_tap_trade": "一键交易",
  "tp_short": "止盈",
  "sl_short": "止损",
  "auto_signals": "自动信号",
  "add_token_placeholder": "添加任意代币（例如 ARB、OP、TIA）",
  "analyze": "分析",
  "analyzing_on": "正在分析 {symbol}（{tf}）…",
  "tap_to_load": "点击以在图表中加载 →",
  "scanning_market": "正在扫描市场…",
  "no_signals": "暂无信号。",
  "money_depth": "资金深度",
  "sr_zones": "支撑/阻力区",
  "bot_analysis": "机器人分析",
  "confidence": "置信度",
  "reasoning": "推理",
  "tp_label": "止盈",
  "sl_label": "止损",
  "risk_reward": "风险 : 收益",
  "levels_from_position": "来自您未平仓位的实时价位",
  "levels_suggested": "建议价位 · 不构成投资建议",
  "toast_opened": "已开 {symbol} {leverage}x 仓位",
  "toast_closed": "已平仓 {symbol} · 盈亏 ${pnl}",
  "toast_closed_pnl": "已平仓 · 盈亏 ${pnl}",
  "ago_s": "{n} 秒前",
  "ago_m": "{n} 分钟前",
  "ago_h": "{n} 小时前",
  "ago_d": "{n} 天前",
  "in_label": "流入",
  "out_label": "流出",
  "confirm_reveal_email": "显示此用户的邮箱？邮箱属于隐私 — 请仅在必要时查看。",
  "view_email_private": "查看邮箱（隐私）",
  "display_name_updated": "显示名称已更新",
  "change_email_sent": "验证链接已发送到新邮箱",
  "username_updated": "用户名已更新",
  "password_changed": "密码已更改。请在其他设备上重新登录。",
  "confirm_logout_all": "要在所有设备上退出登录吗？您需要重新登录。",
  "no_wallet": "未检测到钱包扩展（MetaMask/WalletConnect）。",
  "wallet_rejected": "钱包连接被拒绝。",
  "profile_security": "资料与安全",
  "display_name": "显示名称",
  "display_name_optional": "显示名称（可选）",
  "edit": "编辑",
  "cancel": "取消",
  "change": "更改",
  "in_days": "{days} 天后",
  "username_label": "用户名",
  "username_hint": "3-20 个字母、数字或下划线。每 30 天可更改一次。",
  "username_example": "例如 arash_king",
  "email_private": "邮箱（隐私）",
  "change_email": "更改邮箱",
  "unverified": "未验证",
  "resend_verification": "重新发送验证",
  "new_email": "新邮箱",
  "current_password": "当前密码",
  "new_password": "新密码",
  "confirm_new_password": "确认新密码",
  "send_verification_new": "向新邮箱发送验证",
  "change_email_hint": "您需要通过发送到新邮箱的链接进行确认，然后重新登录。",
  "email_private_hint": "您的邮箱绝不会公开显示。只有您自己能在这里看到。",
  "sessions": "会话",
  "logout_all_devices": "退出所有设备登录",
  "change_password": "修改密码",
  "pw_hint": "至少 8 个字符，包含字母和数字。",
  "update_password": "更新密码",
  "coin_example_placeholder": "例如 BTC、PEPE、TAO...",
  "username_or_email": "用户名或邮箱",
  "forgot_password_q": "忘记密码？",
  "invalid_email": "请输入有效的邮箱",
  "pw_mismatch": "两次输入的密码不一致",
  "username_hint_short": "3-20 个字母、数字或下划线",
  "account_created_verify": "账户已创建！请查收邮件以验证您的账户。",
  "confirm_password_label": "确认密码",
  "missing_verify_token": "缺少验证令牌。",
  "email_verified_msg": "邮箱已验证！",
  "verification_failed": "验证失败。",
  "verifying_email": "正在验证您的邮箱…",
  "email_verified_title": "邮箱已验证",
  "go_to_login": "前往登录",
  "verification_failed_title": "验证失败",
  "verify_expired_hint": "链接已过期？请登录并在设置中使用“重新发送验证”。",
  "back_to_login": "← 返回登录",
  "forgot_password": "忘记密码",
  "forgot_subtitle": "输入您的用户名或邮箱，我们将发送重置链接。",
  "forgot_sent_toast": "如果该账户存在，已发送重置链接。",
  "forgot_sent_full": "如果该账户存在，已发送重置链接。请查收邮件（有效期 15 分钟）。",
  "send_reset_link": "发送重置链接",
  "remembered_it": "想起来了？",
  "missing_reset_token": "缺少重置令牌。请使用邮件中的链接。",
  "pw_requirement": "密码至少需要 8 个字符，并包含字母和数字",
  "password_updated": "密码已更新。",
  "reset_password": "重置密码",
  "reset_subtitle": "为您的账户设置新密码。",
  "reset_invalid": "重置链接无效或缺失。请重新申请。",
  "request_reset_link": "申请重置链接",
  "new_password_label": "新密码",
  "pw_hint2": "至少 8 个字符，包含字母和数字。",
  "update_password_btn": "更新密码",
  "bullish": "看涨",
  "bearish": "看跌",
  "inflow": "流入",
  "outflow": "流出",
  "volume_up": "成交量上升",
  "volume_down": "成交量下降",
  "money_flow_mfi": "资金流量 (MFI 14)",
  "flow_overbought": "超买",
  "flow_oversold": "超卖",
  "flow_bullish": "看涨流入",
  "flow_bearish": "看跌流出",
  "support": "支撑",
  "resistance": "阻力",
  "available_for_trade": "可用于交易",
  "free_balance_after": "之后的可用余额",
  "tab_major": "主流币",
  "tab_shitcoins": "Shitcoin",
  "tab_nfts": "NFT",
  "filter_direction": "方向",
  "buy_only": "仅买入",
  "sell_only": "仅卖出",
  "min_confidence": "最低置信度",
  "confirm": "确认",
  "safety_score": "安全评分",
  "liquidity_lock": "流动性锁定",
  "locked": "已锁定",
  "unlocked": "未锁定",
  "honeypot": "蜂蜜罐合约",
  "honeypot_safe_label": "安全",
  "honeypot_risk": "风险",
  "nft_demo_notice": "模拟交易 — 不会购买真实 NFT",
  "view_on_opensea": "在 OpenSea 上查看",
  "volume_24h": "成交量 (24 小时)",
  "nft_position_opened": "NFT 仓位已开（模拟）",
  "crypto_positions_title": "加密货币与 Shitcoin 仓位",
  "nft_positions_title": "NFT 仓位",
  "min_safety_required": "安全评分必须 ≥ 75 才能交易",
  "amount_exceeds_balance": "金额超过您的可用余额",
  "amount_gt_zero": "金额必须大于 0",
  "confirm_trade": "确认交易",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "没有未平仓的 NFT 仓位",
  "floor": "地板价",
  "rr_short": "盈亏比",
  "best_marketplace": "最佳市场",
  "story": "故事",
  "show_more": "展开",
  "show_less": "收起",
  "view_chart": "查看图表",
  "reason_sma_bull": "SMA9 高于 SMA21（看涨趋势）",
  "reason_sma_bear": "SMA9 低于 SMA21（看跌趋势）",
  "reason_rsi_oversold": "超卖",
  "reason_rsi_overbought": "超买",
  "reason_rsi_neutral": "中性",
  "reason_pos_momentum": "正向动量",
  "reason_neg_momentum": "负向动量",
  "reason_insufficient": "数据不足",
  "reason_whale_accum": "鲸鱼吸筹",
  "reason_rising_floor": "地板价上升",
  "reason_falling_floor": "地板价下降",
  "reason_high_rarity": "高稀有度",
  "reason_mid_rarity": "中等稀有度",
  "nft_trade_history": "NFT 交易记录",
  "no_nft_trades": "暂无已平仓的 NFT 交易",
  "entry_floor": "入场地板价",
  "exit_floor": "出场地板价",
  "verify_reminder": "您的邮箱尚未验证 — 验证后即可解锁交易。",
  "verify_now": "立即验证",
  "dismiss": "关闭",
  "trusted_devices": "活跃会话 · 已登录设备",
  "font_size": "字体大小",
  "font_small": "小",
  "font_medium": "中",
  "font_large": "大",
  "sessions_hint": "当前登录您账户的手机和浏览器（不是交易所 API 密钥）。",
  "unknown_device": "未知设备",
  "this_device": "本设备",
  "current_session": "当前",
  "last_active": "最后活跃",
  "revoke_all_others": "退出所有其他设备",
  "revoke_all_others_done": "已退出所有其他设备",
  "no_other_devices": "没有其他活跃设备",
  "device_revoked": "设备已退出",
  "ui_logo_alt": "Firebird / Simorgh Trade 标志",
  "ui_logo_switch_hint": "点击切换标志",
  "ui_vpn_info": "VPN 信息"
};
export default zh;
